<template>
  <div>
    <div style=" font-size: 18px;padding-bottom: 20px;text-align: center;">
      {{this.warnReasonId ? '编辑预警原因' : '新增预警原因'}}
    </div>
    <a-form-model label-position="right" :model="form.data" :rules="formRules" ref="warnReasonForm">
      <a-form-model-item label="预警原因" :label-width="formLabelWidth" prop="reason">
        <a-input v-model="form.data.reason" auto-complete="off" placeholder="请输入预警原因"></a-input>
      </a-form-model-item>
    </a-form-model>
    <!--    <div slot="footer" class="dialog-footer" style="text-align: center;">-->
    <!--      <a-button type="primary" @click="cancel()"-->
    <!--                 class="project-dialog-button">取消-->
    <!--      </a-button>-->
    <!--      <a-button type="primary" @click="save"-->
    <!--                 class="project-dialog-button">保存-->
    <!--      </a-button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import {findWarnReason, updateWarnReason, saveWarnReason} from '../../../api/warnReson';

async function getWarnReason() {
  if (this.form.data.id) {
    const warnReason = await findWarnReason(this.form.data.id);
    if (warnReason.code === 1200) {
      this.$set(this.form.data, 'reason', warnReason.data.warnReasons.reason);
    }
  } else {
    this.form.data = {};
  }
}

function save() {
  this.$refs.warnReasonForm.validate(async (valid) => {
    if (valid) {
      if (this.form.data.id) {
        const resultUpdate = await updateWarnReason(this.form.data);
        const messagesUpdate = '更新成功';
        if (resultUpdate.code === 1200) {
          this.$message.success(messagesUpdate);
          this.getList();
          this.form.data = {};
        } else {
          this.$message.error('更新失败');
        }
      } else {
        const resultAdd = await saveWarnReason(this.form.data);
        const messagesAdd = '添加成功';
        if (resultAdd.code === 1200) {
          this.$message.success(messagesAdd);
          this.form.data = {};
          this.getList();

        } else {
          this.$message.error('添加失败');

        }
      }
    }
  });
}

function cancel() {
  this.$refs.warnReasonForm.resetFields();
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'WarnReasonEdit',
  props: {
    warnReasonId: String,
    onSaveHandler: Function,
    onCancelHandler: Function,
    getList: Function
  },
  data() {
    return {
      formLabelWidth: '90px',
      form: {
        data: {
          id: '',
          reason: '',
        },
      },
      formRules: {
        reason: [
          { required: true, message: '请输入预警理由', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    warnReasonId(val) {
      this.form.data = {};
      this.form.data.id = val;
      this.getWarnReason();
    },
  },
  created() {
    this.form.data.id = this.warnReasonId;
    this.getWarnReason();
  },
  methods: {
    save,
    cancel,
    getWarnReason,
  },
};
</script>

<style scoped>

</style>
